import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Welcome from "../pages/welcome/page";
import Home from "../pages/home/page";
import Rooms from "../pages/rooms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Welcome />,
  },
  {
    path: "/gostilna",
    element: <Home />,
  },
  {
    path: "/sobe",
    element: <Rooms />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;